<div class="overflow-y-auto height-100" #pageContent (scroll)="onScrollEvent()">
    <div class="connect-common-page-header">
        <div class="header-block padding-bottom-5 width-80 padding-left-15">
            <span class="display-block header-text semi-bold-font">Referral Form</span>
            <span class="header-details" [ngClass]="{'dark-green bold-font': isReferralCompleteOrDeclineOrSubmitted}">{{isReferralCompleteOrDeclineOrSubmitted ? formatterSubmissionText: 'Please provide referral details'}}</span>
        </div>
        <div class="display-inline referral-submit-btn margin-right-10" *ngIf="showSubmitReferralButton">
            <button mat-raised-button color="accent" (click)="submitReferral()">
                <span class="bold-font">Submit Referral</span>
                <mat-icon class="padding-left-5">play_circle_filled</mat-icon>
            </button>
        </div>
        <div class="display-inline referral-submit-btn" *ngIf="isReferralAddedAsParticipant">
            <button mat-raised-button color="white" (click)="returnToOverview()">
                <span class="bold-font">Return to File Overview</span>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div class="padding-10" *ngIf="formGroup">
        <form [formGroup]="formGroup" class="padding-5">
            <mat-vertical-stepper #linearVerticalStepper="matVerticalStepper" [linear]="false">
                <mat-step formGroupName="referralForm">
                    <ng-template matStepLabel class="form-sub-header">Referred to:</ng-template>
                    <div class="padding-top-10">
                        <dp-connect-auto-suggest #receivingLawFirmNameAutoSuggest [isValidatorRequired]="'true'"
                                                 [readonly]="isReferralCompleteOrDeclineOrSubmitted"
                                                 [default]="formGroup.controls?.referralForm.controls?.receivingLawFirmName"
                                                 [placeHolder]="'Search available law firms'" [type]="'ACCOUNT_LIST'"
                                                 [autoFocus]="'true'"
                                                 (onOptionSelection)="accountSelected($event)">
                        </dp-connect-auto-suggest>
                    </div>
                    <div class="padding-top-10" *ngIf="formGroup.get('referralForm').get('receivingSolicitorAddress').value">
                        <mat-form-field class="width-100">
                            <mat-label>Law Firm Address</mat-label>
                            <input matInput formControlName="receivingSolicitorAddress">
                        </mat-form-field>
                    </div>
                    <div class="padding-top-10" *ngIf="!isSolicitorDropDownMode">
                        <dp-connect-auto-suggest
                                [readonly]="isReferralCompleteOrDeclineOrSubmitted"
                                [default]="formGroup.controls?.referralForm.controls?.receivingSolicitorName"
                                [placeHolder]="'Search available solicitors'" [type]="'SOLICITOR'"
                                (onOptionSelection)="contactSelected($event,'receivingSolicitorId','receivingSolicitorName')">
                        </dp-connect-auto-suggest>
                    </div>
                    <div class="padding-top-10"  *ngIf="isSolicitorDropDownMode">
                        <mat-form-field class="width-100">
                            <mat-label>Solicitor</mat-label>
                            <select matNativeControl formControlName="receivingSolicitorId" (change)="updateSolicitorName($event)" aria-label="Select Solicitor">
                                <option *ngFor="let option of solicitorListByFirm"
                                            [value]="option.id">{{ option.fullName }}
                                </option>
                            </select>
                        </mat-form-field>
                    </div>
                    <div class="padding-top-20">
                        <button mat-button matStepperPrevious class="unity-btn-bg  margin-right-10"><span
                                class="padding-right-10"><i class="fa fa-chevron-left"></i></span>Back
                        </button>
                        <button mat-button matStepperNext class="unity-btn-bg">Next<span class="padding-left-10"><i
                                class="fa fa-chevron-right"></i></span></button>
                    </div>
                </mat-step>
                <mat-step formGroupName="referralForm">
                    <ng-template matStepLabel class="form-sub-header">Deal Information</ng-template>
                    <div class="padding-top-10">
                        <mat-form-field class="padding-right-10">
                            <mat-label>Closing Date</mat-label>
                            <input matInput formControlName="closingDate"
                                   [matDatepicker]="closingDatePicker"
                                   placeholder="'(DD/MM/YYYY)'"
                            >
                            <mat-datepicker-toggle matSuffix
                                                   [for]="closingDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #closingDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field class="padding-right-10">
                            <mat-label>Transaction Type</mat-label>
                            <select matNativeControl formControlName="transactionType" (change)="transactionTypeUpdate($event)" required aria-label="Select Transaction Type">
                                <option *ngFor="let option of transactionType"
                                            [value]="option.value">{{ option.name }}
                                </option>
                            </select>
                            <mat-error>This field is required</mat-error>
                        </mat-form-field>
                        <mat-form-field class="padding-right-10" *ngIf="isPurchase() || isSale()">
                            <mat-label>Purchase is of</mat-label>
                            <select matNativeControl formControlName="purchaseType" aria-label="Purchase is of">
                                <option *ngFor="let option of purchaseOf"
                                            [value]="option.value">{{ option.name }}
                                </option>
                            </select>
                        </mat-form-field>
                    </div>
                    <div class="padding-top-10">
                        <dp-address-form [formGroup]="getPropertyAddressFormGroup()"
                                         [formGroupName]="'propertyAddress'"
                                         [addressLine1Label]="'Property Address'"
                        ></dp-address-form>
                    </div>
                    <div class="padding-top-10" *ngIf="isPurchase() || isSale()">
                        <mat-form-field class="padding-right-10">
                            <mat-label>Purchase Price</mat-label>
                            <input matInput currencyMask [options]="{max: '999999999.99'}" formControlName="purchasePrice">
                        </mat-form-field>
                        <mat-form-field class="padding-right-10">
                            <mat-label>Deposit Amount</mat-label>
                            <input matInput currencyMask [options]="{max: '999999999.99'}" formControlName="depositAmount">
                        </mat-form-field>
                        <mat-form-field class="padding-right-10">
                            <mat-label>Total Commissions</mat-label>
                            <input matInput currencyMask [options]="{max: '999999999.99'}" formControlName="totalCommissionAmount">
                        </mat-form-field>
                    </div>

                    <ng-container *ngIf="isPurchase() || isSale()">
                        <div class="padding-top-10">
                            <dp-connect-auto-suggest
                                    [default]="formGroup.controls?.referralForm.controls?.otherSolicitorName"
                                    [readonly]="isReferralCompleteOrDeclineOrSubmitted"
                                    [placeHolder]="'Other Parties Solicitor'" [type]="'SOLICITOR'"
                                    [dropDownOptions]="otherSideSolicitorAutoSuggestList"
                                    [isDropdownArrowVisible]="true"
                                    [searchTextValue]="getOtherSolicitorName()"
                                    [lawFirmId]="getOtherLawFirmId()"
                                    (onOptionSelection)="contactSelected($event,'otherSolicitorId','otherSolicitorName')">
                            </dp-connect-auto-suggest>
                        </div>
                        <div class="padding-top-10">
                            <dp-connect-auto-suggest #otherLawFirmNameAutoSuggest
                                                     [readonly]="isReferralCompleteOrDeclineOrSubmitted"
                                                     [default]="formGroup.controls?.referralForm.controls?.otherLawFirmName"
                                                     [placeHolder]="'Other Parties Law Firm'" [type]="'LAW_FIRM'"
                                                     (onOptionSelection)="contactSelected($event ,'otherLawFirmId','otherLawFirmName')">
                            </dp-connect-auto-suggest>
                        </div>
                        <div class="padding-top-10">
                            <mat-form-field class="width-100">
                                <mat-label>Client's Real Estate Agent</mat-label>
                                <input matInput formControlName="realEstateAgentName">
                            </mat-form-field>
                        </div>
                        <div class="padding-top-10">
                            <dp-connect-auto-suggest
                                    [readonly]="isReferralCompleteOrDeclineOrSubmitted"
                                    [default]="formGroup.controls?.referralForm.controls?.realEstateBrokerageFirmName"
                                    placeHolder="Client's Real Estate Broker" [type]="'REALESTATEBROKER'"
                                    (onOptionSelection)="contactSelected($event,'realEstateBrokerageFirmId' ,'realEstateBrokerageFirmName')">
                            </dp-connect-auto-suggest>
                        </div>
                    </ng-container>
                    <div class="padding-top-10" *ngIf="isPurchase() || isMortgage()">
                        <mat-form-field class="padding-right-10">
                            <mat-label>New Mortgage Amount</mat-label>
                            <input matInput currencyMask [options]="{max: '999999999.99'}" formControlName="newMortgageAmount">
                        </mat-form-field>
                    </div>
                    <div class="padding-top-10" *ngIf="isPurchase() || isMortgage()">
                        <mat-form-field class="width-100">
                            <mat-label>Mortgage Notes</mat-label>
                            <textarea rows="3" matInput formControlName="mortgageNotes"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="padding-top-20">
                        <button mat-button matStepperPrevious class="unity-btn-bg margin-right-10"><span
                                class="padding-right-10"><i class="fa fa-chevron-left"></i></span>Back
                        </button>
                        <button mat-button matStepperNext class="unity-btn-bg">Next<span class="padding-left-10"><i
                                class="fa fa-chevron-right"></i></span></button>
                    </div>
                </mat-step>
                <mat-step formGroupName="referralForm">
                    <ng-template matStepLabel class="form-sub-header">Client(s) Contact Information</ng-template>
                    <mat-accordion>
                        <div formArrayName="referredClients"
                             *ngFor="let item of formGroup.controls?.referralForm.controls?.referredClients.controls; let i = index;">
                            <div [formGroupName]="i" class="padding-top-10 display-inline" style="width: 95%;">
                                <mat-expansion-panel [expanded]="true">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Client #{{i+1}}
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            {{getClientHeaderInfo(i)}}
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>

                                    <div>
                                        <mat-form-field class="padding-right-10">
                                            <mat-label>First name</mat-label>
                                            <input matInput formControlName="firstName" required my-auto-focus  maxlength="50">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                        <mat-form-field class="padding-right-10">
                                            <mat-label>Middle Name(s)</mat-label>
                                            <input matInput formControlName="middleName" maxlength="50">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Last name</mat-label>
                                            <input matInput formControlName="lastName" required maxlength="100">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="padding-top-10">
                                        <mat-form-field class="padding-right-10">
                                            <mat-label>Role</mat-label>
                                            <select matNativeControl formControlName="role" required aria-label="Select Role">
                                                <option *ngFor="let option of clientRoleOptions"
                                                            [value]="option.value">{{ option.name }}
                                                </option>
                                            </select>
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                        <ng-container formArrayName="telephones">
                                            <mat-form-field class="padding-right-10" formGroupName="0">
                                                <mat-label>Phone Number</mat-label>
                                                <input matInput formControlName="telephoneNumber" dp-phone-number
                                                       (blur)="removeValidation(item)">
                                                <mat-error *ngIf="item.get('telephones').controls[0].controls.telephoneNumber.errors?.required
                                                         && item.get('email').errors?.required">Email or Phone is
                                                    required
                                                </mat-error>
                                                <mat-error *ngIf="item.get('email').errors?.pattern">
                                                    Email must be a valid email address
                                                </mat-error>
                                            </mat-form-field>
                                        </ng-container>
                                        <mat-form-field class="padding-right-10">
                                            <mat-label>Email</mat-label>
                                            <input matInput formControlName="email" (blur)="removeValidation(item)">
                                            <mat-error *ngIf="item.get('telephones').controls[0].controls.telephoneNumber.errors?.required
                                                         && item.get('email').errors?.required">Email or Phone is
                                                required
                                            </mat-error>
                                            <mat-error *ngIf="item.get('email').errors?.pattern">Email must be a valid
                                                email address
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="padding-top-10" *ngIf="getClientFormGroup(i)">
                                        <dp-address-form [formGroup]="getClientFormGroup(i)"
                                                         [formGroupName]="'address'"
                                                         [addressLine1Label]="'Current Address'"
                                        ></dp-address-form>
                                    </div>

                                </mat-expansion-panel>
                            </div>
                            <button *ngIf="!isReferralCompleteOrDeclineOrSubmitted" class="mat-card-icon padding-top-15" style="position: absolute" mat-icon-button
                                    aria-label="Delete Client"
                                    (click)="deleteClient(item)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </mat-accordion>
                    <div class="padding-top-20">

                        <button *ngIf="!isReferralCompleteOrDeclineOrSubmitted" mat-button class="unity-btn-bg margin-right-40 margin-bottom-10" (click)="addNewClientInfo()"><span
                                class="padding-right-10 "><i class="fa fa-user-plus"></i></span>{{formGroup.controls?.referralForm.controls?.referredClients.controls.length > 0 ? 'Add Another Client': 'Add New Client'}}
                        </button>
                        <button mat-button matStepperPrevious class="unity-btn-bg margin-right-10"><span
                                class="padding-right-10"><i class="fa fa-chevron-left"></i></span>Back
                        </button>
                        <button mat-button matStepperNext class="unity-btn-bg">Next<span class="padding-left-10"><i
                                class="fa fa-chevron-right"></i></span></button>
                    </div>
                </mat-step>
                <mat-step formGroupName="referralForm">
                    <ng-template matStepLabel class="form-sub-header">Notes</ng-template>
                    <div class="padding-top-10">
                        <mat-form-field class="width-100">
                            <mat-label>Notes</mat-label>
                            <textarea rows="3" matInput formControlName="referralNotes"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="padding-top-20">
                        <button mat-button matStepperPrevious class="unity-btn-bg margin-right-10"><span
                                class="padding-right-10"><i class="fa fa-chevron-left"></i></span>Back
                        </button>
                        <button mat-button matStepperNext class="unity-btn-bg">Next<span class="padding-left-10"><i
                                class="fa fa-chevron-right"></i></span></button>
                    </div>
                </mat-step>
                <mat-step>
                    <ng-template matStepLabel class="form-sub-header">Attachments</ng-template>
                    <div class="padding-top-10">
                        <dp-file-upload
                                (documentUploaded)="documentUploaded($event)"
                                (prepareTransactionBeforeUpload) = "prepareTransactionBeforeUpload()"
                                [transactionType]="'REFERRAL'"
                                [transactionId] = "this.referral?.id"
                        ></dp-file-upload>
                    </div>
                    <div class="padding-top-10">
                        <mat-list role="list">
                            <mat-list-item role="listitem" *ngFor="let document of referralDocuments;let index=index"
                                           (mouseenter)="hoveredIndex=index">
                                <div class="mat-card-connect-client-list-left">
                                    <mat-icon class="mat-card-connect-icon" title="{{document.description}}"
                                              *ngIf="document.isVirusClean()">attachment
                                    </mat-icon>
                                    <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                              *ngIf="document.isVirusInfected()">block
                                    </mat-icon>
                                    <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                              *ngIf="document.isVirusPending()">warning
                                    </mat-icon>
                                    <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                              *ngIf="document.isVirusInProgress()">warning
                                    </mat-icon>
                                    <span class="mat-card-list-text">{{document.documentName}} - {{document.description}}</span>

                                </div>
                                <div class="mat-card-connect-client-list-right" *ngIf="index==hoveredIndex">
                                    <button class="mat-card-icon" mat-icon-button
                                            aria-label="Delete Document"
                                            (click)="deleteDocument(document)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                                <mat-divider></mat-divider>
                            </mat-list-item>
                        </mat-list>
                    </div>
                    <div class="padding-top-20">
                        <button mat-button matStepperPrevious class="unity-btn-bg margin-right-10">
                            <span  class="padding-right-10"><i class="fa fa-chevron-left"></i></span>Back
                        </button>
                        <button mat-button matStepperNext class="unity-btn-bg">Next
                            <span class="padding-left-10"><i class="fa fa-chevron-right"></i></span>
                        </button>
                    </div>
                </mat-step>
                <mat-step formGroupName="referralForm">
                    <ng-template matStepLabel class="form-sub-header">My Contact Information</ng-template>
                    <div>
                        <mat-form-field class="padding-right-10">
                            <mat-label>First name</mat-label>
                            <input matInput formControlName="referringAgentFirstName" maxlength="50" required>
                            <mat-error>This field is required</mat-error>
                        </mat-form-field>
                        <mat-form-field class="padding-right-10">
                            <mat-label>Middle Name(s)</mat-label>
                            <input matInput formControlName="referringAgentMiddleName" maxlength="50">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Last name</mat-label>
                            <input matInput formControlName="referringAgentLastName" maxlength="100" required>
                            <mat-error>This field is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="padding-top-10">
                        <mat-form-field class="padding-right-10">
                            <mat-label>Role</mat-label>
                            <select matNativeControl formControlName="referringAgentRole" required aria-label="Role">
                                <option *ngFor="let option of agentRoleOptions"
                                            [value]="option.value">{{ option.name }}
                                </option>
                            </select>
                            <mat-error>This field is required</mat-error>
                        </mat-form-field>
                        <ng-container formArrayName="referringAgentTelephones">
                            <mat-form-field class="padding-right-10" formGroupName="0">
                                <mat-label>Phone Number</mat-label>
                                <input matInput formControlName="telephoneNumber" dp-phone-number required>
                                <mat-error>This field is required</mat-error>
                            </mat-form-field>
                        </ng-container>
                        <mat-form-field class="padding-right-10">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="referringAgentEmail" required [pattern]="emailPattern" maxlength="100">
                            <mat-error
                                    *ngIf="formGroup.controls?.referralForm.controls?.referringAgentEmail?.errors?.required">
                                Email is required
                            </mat-error>
                            <mat-error
                                    *ngIf="formGroup.controls?.referralForm.controls?.referringAgentEmail?.errors?.pattern">
                                Email must be a valid email address
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="padding-top-10">
                        <mat-form-field class="padding-right-10">
                            <mat-label>Company Name</mat-label>
                            <input matInput formControlName="referringAgentCompany" maxlength="250">
                        </mat-form-field>
                    </div>
                    <div class="padding-top-20">
                        <button mat-button matStepperPrevious class="unity-btn-bg margin-right-10"><span
                                class="padding-right-10"><i class="fa fa-chevron-left"></i></span>Back
                        </button>
                        <button mat-button class="unity-btn-bg margin-left-10" (click)="backToHomePage()" *ngIf="!isReferralCompleteOrDeclineOrSubmitted">
                            Done<span class="padding-left-10"><i class="fa fa-check"></i></span></button>

                    </div>
                </mat-step>

            </mat-vertical-stepper>
        </form>
    </div>

    <div class="back-to-top-block d-12 d-lg-none ">
        <button id="backToTopBtn" title="Go to top" #backToTopBtn (click)="backToTop()"><i class="fa fa-arrow-up"></i>
        </button>
    </div>
</div>
